import { useQuery } from '@apollo/client';
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import Input from 'layout/atoms/Input/Input';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import FormField from 'layout/molecules/FormField/FormField';
import FormSaveActions from 'layout/molecules/FormSaveActions/FormSaveActions';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { addBrand, selectBrandById, updateBrand } from 'store/parameters/brandsSlice';
import useBrandValidation from './useBrandValidation';
function BrandEditor({ create = false }) {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const brandId = (_a = useSelector(selectModalByName(create ? 'brandCreator' : 'brandEditor'))) === null || _a === void 0 ? void 0 : _a.id;
    const brandDetails = useSelector((state) => selectBrandById(state, brandId || '')) || null;
    const { t } = useTranslation(['specification', 'common']);
    const { data: tenant } = useQuery(GET_CURRENT_TENANT);
    const tenantId = (_c = (_b = tenant === null || tenant === void 0 ? void 0 : tenant.me) === null || _b === void 0 ? void 0 : _b.currentTenant) === null || _c === void 0 ? void 0 : _c.id;
    const [formValues, setFormValues] = useState({
        name: '',
    });
    const { errors, isValid, pendingFields, markTouched, validateAll } = useBrandValidation(formValues, t);
    useEffect(() => {
        if (!create && brandDetails) {
            setFormValues({
                name: brandDetails.name,
            });
        }
    }, [create, brandDetails, brandId]);
    const handleFormChange = ({ target: { name, value }, }) => {
        setFormValues((values) => (Object.assign(Object.assign({}, values), { [name]: value })));
    };
    const handleCancel = () => {
        dispatch(closeModal({ name: create ? 'brandCreator' : 'brandEditor' }));
    };
    const handleFormSubmit = () => {
        if (!validateAll())
            return;
        if (create) {
            dispatch(addBrand({ tenantId, name: formValues.name }));
        }
        else {
            dispatch(updateBrand({ brandId: brandDetails.id, name: formValues.name }));
        }
        dispatch(closeModal({ name: create ? 'brandCreator' : 'brandEditor' }));
    };
    return (React.createElement(Modal, { name: create ? 'brandCreator' : 'brandEditor', size: "s", header: React.createElement(Label, { weight: "strong" }, create ? t('add_brand') : t('edit_brand')), footer: React.createElement(FormSaveActions, { isValid: isValid, isLoading: false, pendingFields: pendingFields, onSave: handleFormSubmit, onCancel: handleCancel, validateAll: validateAll }), onClose: handleCancel },
        React.createElement(FormField, { label: t('common:name'), error: errors.name },
            React.createElement(Input, { value: formValues === null || formValues === void 0 ? void 0 : formValues.name, onChange: handleFormChange, onBlur: () => markTouched('name'), name: "name", error: Boolean(errors.name), autoFocus: true }))));
}
export default memo(BrandEditor);
